import { createStore } from "redux";

const initialState = {};

function reducer(state = initialState) {
  return state;
}

export const store = createStore(reducer);
